import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";

export const IconChip: React.FC<CentralIconBaseProps> = (props) => {
  return <CentralIconBase {...props} ariaLabel="chip, esim"><path d="M7.75 5.25V3.75M12 5.25V3.75M16.25 5.25V3.75M7.75 20.25V18.75M12 20.25V18.75M16.25 20.25V18.75M3.75 3.75H20.25V20.25H3.75V3.75ZM7.75 8.75H16.25V15.25H7.75V8.75Z" stroke="currentColor" strokeWidth="1.5" strokeLinecap="square"/></CentralIconBase>;
};

export default IconChip;
